import { atom } from "recoil";

export const LoaiDiaDiemState = atom({
  key: "LoaiDiaDiemState",
  default: "ALL",
});
